import { render, staticRenderFns } from "./NewPartnerCard.vue?vue&type=template&id=749a829e&scoped=true&"
import script from "./NewPartnerCard.vue?vue&type=script&lang=js&"
export * from "./NewPartnerCard.vue?vue&type=script&lang=js&"
import style0 from "./NewPartnerCard.vue?vue&type=style&index=0&id=749a829e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749a829e",
  null
  
)

export default component.exports